import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../services/Api';

const initialState = {
  permissions: [],
  selectedPermission:null,
  loading: false,
  error: null,
  message: null,
};

// Fetch user permissions
export const fetchUserPermissions = createAsyncThunk(
  'userPermissions/fetchUserPermissions',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/permissions?userId=${userId}`, {
        params: { userId },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);



// Update user permission
export const updateUserPermission = createAsyncThunk(
  'userPermissions/updateUserPermission',
  async (permissionData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/permissions`, permissionData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);


const userPermissionsSlice = createSlice({
  name: 'userPermissions',
  initialState,
  reducers: {
    setSelectedPermission: (state, action) => {
        state.selectedPermission = action.payload;
      },
      clearSelectedPermission: (state) => {
        state.selectedPermission = null;
      },
    clearPermissionAlerts: (state) => {
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
        state.selectedPermission=action.payload
      })
      .addCase(fetchUserPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserPermission.fulfilled, (state, action) => {
        state.loading = false;        
        state.message = 'Les modifications prendront effet lors de la prochaine connexion.';
        state.selectedPermission=action.payload
      })
      .addCase(updateUserPermission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPermissionAlerts,setSelectedPermission,clearSelectedPermission } = userPermissionsSlice.actions;
export default userPermissionsSlice.reducer;
